import { render, staticRenderFns } from "./AddOnItemsModal.vue?vue&type=template&id=f26084c8"
import script from "./AddOnItemsModal.vue?vue&type=script&lang=js"
export * from "./AddOnItemsModal.vue?vue&type=script&lang=js"
import style0 from "./AddOnItemsModal.vue?vue&type=style&index=0&id=f26084c8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports